<template>
  <div>
    <label class="control-label">{{ node.name }}({{ node.nodeId }})</label>
    <!-- 自定义帮助help -->
    <div class="form-inline">
      <div class="control-label left-label">审批要点:</div>
      <eco-input style="width: 55%" type="textarea" v-model="propertie.help" :maxlength="maxlength"></eco-input>
      <br />
    </div>
  </div>
</template>

<script>
import req from '@/request.js'
import { mapState, mapActions } from 'vuex'
import { Message } from 'element-ui'
const FlowNodeHelp = () => import('@/components/flow/FlowNodeHelp.vue')
export default {
  name: 'FlowNodeAttributes',
  components: { FlowNodeHelp },
  props: {
    //任务节点信息
    node: {
      type: Object,
      required: true
    },
    //节点属性批量勾选配置
    nodeAttr: {
      type: Object,
      required: true
    },
    //流程配置信息
    defConfigData: {
      type: Object,
      required: true
    }
  },
  watch: {
    propertie: {
      handler(newValue, oldValue) {
        let path = 'nodeSetData.bpmDefSetting.nodePropertieMap.' + this.node.nodeId
        let obj = {}
        obj[path] = newValue
        //更新vuex里面defConfigData配置数据
        this.$store.dispatch('flow/updateConfig', obj)
      },
      deep: true
    },
    nodePropertieMap: {
      handler(newValue, oldValue) {
        //更新vuex里面defConfigData配置数据
        this.$store.dispatch('flow/updateConfig', {
          'nodeSetData.bpmDefSetting.nodePropertieMap': newValue
        })
      },
      deep: true
    },
    nodeAttr: {
      handler(newValue, oldValue) {
        this.propertie.jumpType = newValue.jumpType //批量勾选跳转类型
        this.propertie.notifyType = newValue.notify //批量勾选通知类型
        if (newValue.backMode_all != '' && this.node.type != 'signTask') {
          this.propertie.backMode = 'direct' //批量勾选驳回后返回
        } else {
          this.propertie.backMode = 'normal'
        }
        if (newValue.skipExecutorEmpty_all != '') {
          this.propertie.skipExecutorEmpty = true //批量勾选执行人为空时跳过
        } else {
          this.propertie.skipExecutorEmpty = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      value: '', //帮助内容
      title: '', //帮助弹框标题
      approvalArea: [
        // { key: "approvalOpinion", value: "审批意见" },
        // { key: "zFile", value: "正文" },
        // { key: "file", value: "附件" },
        { key: 'processRecord', value: '处理记录' }
        // { key: "imageBpm", value: "流程图" }
      ], //审批区域显示
      propertie: {}, //单个节点的配置信息
      selectNodeList: [], //可驳回的节点
      nodePropertieMap: {},
      maxlength: 300
    }
  },
  methods: {
    //监听任务帮助对话框确认事件
    handleHelpSave(data) {
      if (this.title == '【全局任务节点】帮助提示') {
        this.nodePropertieMap = JSON.parse(JSON.stringify(this.defConfigData.nodeSetData.bpmDefSetting.nodePropertieMap))
        for (let key in this.nodePropertieMap) {
          this.nodePropertieMap[key].helpGlobal = data //获取全局任务节点任务帮助提示
        }
      } else {
        this.propertie.help = data //获取单个任务节点任务帮助提示
      }
    },
    //点击帮助事件
    helpClick(nodeId, val) {
      let Base64 = require('js-base64').Base64
      let name = '全局任务节点'
      if (nodeId != '') {
        name = '单个任务节点'
      }
      this.title = '【' + name + '】帮助提示'
      if (val != '') {
        this.value = Base64.decode(val, 'utf-8') //单个任务节点帮助内容
      } else {
        this.value = Base64.decode(this.propertie.helpGlobal) //全局任务节点帮助内容
      }
      setTimeout(() => {
        this.$refs.flowNodeHelp.showDialog() //显示帮助富文本框
      })
    },
    //判断前置后置处理器是否存在
    checkHandler(handler) {
      if (!handler) return
      req.get('${bpmModel}/flow/node/v1/validHandler?handler=' + handler).then(function (data) {
        data = data.data
        if (data.result != '0') {
          Message.warning('接口' + handler + '有误，原因：' + data.msg)
        }
      })
    }
  },
  mounted() {
    this.propertie = this.defConfigData.nodeSetData.bpmDefSetting.nodePropertieMap[this.node.nodeId] //获取单个节点的配置信息
    //获取可驳回节点
    for (let i = 0; i < this.defConfigData.nodeSetData.nodes.length; i++) {
      if (
        this.defConfigData.nodeSetData.nodes[i].type == 'signTask' ||
        this.defConfigData.nodeSetData.nodes[i].type == 'userTask' ||
        this.defConfigData.nodeSetData.nodes[i].type == 'callActivity'
      ) {
        this.selectNodeList.push(this.defConfigData.nodeSetData.nodes[i])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
>>> label.el-radio-horizontal {
  margin: 5px 10px 0 0;
}
>>> label.el-checkbox {
  margin: 5px 10px 0 0;
}
.ht {
  float: left;
  width: 70%;
}
.form-inline {
  float: left;
  width: 100%;
}
.left-label {
  width: 24%;
  float: left;
}
.control-label {
  word-break: break-all;
  text-align: right;
  color: #545252;
  font-size: 12px;
  padding: 0px 10px !important;
  font-weight: bold;
  line-height: 35px;
}
div >>> .box-card {
  margin-bottom: 20px;
}

div >>> .box-card .clearfix {
  padding-top: 20px;
}

div >>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
}

div >>> .el-button {
  padding: 7px;
  margin-right: 10px;
  margin-left: 0px !important;
}
</style>
